import { render, staticRenderFns } from "./BookTextTableWindow.vue?vue&type=template&id=542fdafb&scoped=true&"
import script from "./BookTextTableWindow.vue?vue&type=script&lang=js&"
export * from "./BookTextTableWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542fdafb",
  null
  
)

export default component.exports